import { FC } from "react";
import { GiPokecog } from 'react-icons/gi';
import { PageSizer, SizerMode } from "../../components/page/PageSizer";
import { PageContainer } from "../../components/page/PageContainer";
import { PageHeader } from '../../components/page/PageHeader';
import strings from './tenantSettings.translations';
import { SuperAdminSettingsGrid } from "./grids/SuperAdminSettingsGrid";

export const SuperAdminTenantSettingsPage: FC = () => {
  return (
    <PageContainer customHeader={<PageHeader pageTitle={strings.superAdmin.pageTitle} icon={<GiPokecog />}/>}>
      <PageSizer className="relative flex-col flex gap-5" mode={SizerMode.PAGE}>
        <SuperAdminSettingsGrid/>
      </PageSizer>
    </PageContainer>
  );
};